
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalCross as ObiBuoySphericalCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-cross.js';
 
 
 

 
 export const ObiBuoySphericalCross = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-cross',
   elementClass: ObiBuoySphericalCrossElement,
   events: {
     
   }
  });
 
 